import { api_GET, api_POST, api_PUT, api_DELETE } from "./_api";

const relacaoResiduoVolumetria_api = {

    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RelacaoResiduoVolumetria/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RelacaoResiduoVolumetria/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST('RelacaoResiduoVolumetria', obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT('RelacaoResiduoVolumetria', obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    Delete: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`RelacaoResiduoVolumetria/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
}
export default relacaoResiduoVolumetria_api;